import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ABSplitForm from './ABSplitForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    aPath: 50,
    ...otherProps.initialValues,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ABSplitForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ABSplit/ABSplitForm.container.js